// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gTV7E","comment":"styles_comment__1HROI"};